import com.kanati.admin.app.AdminApp
import kotlinx.browser.document
import org.w3c.dom.HTMLTextAreaElement
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent
import org.jetbrains.compose.web.renderComposable

fun main() {
    document.title = "Kanati Admin Web"
    installTextareaIndentHandler()

    if (document.getElementById(ROOT_ELEMENT_ID) == null) {
        val root = document.createElement("div")
        root.id = ROOT_ELEMENT_ID
        document.body?.appendChild(root)
    }

    renderComposable(rootElementId = ROOT_ELEMENT_ID) {
        AdminApp()
    }
}

private const val ROOT_ELEMENT_ID = "root"

private fun installTextareaIndentHandler() {
    document.addEventListener(
        type = "keydown",
        callback = { event ->
            val keyboardEvent = event as? KeyboardEvent ?: return@addEventListener
            if (keyboardEvent.key != "Tab" || keyboardEvent.shiftKey || keyboardEvent.altKey || keyboardEvent.ctrlKey || keyboardEvent.metaKey) {
                return@addEventListener
            }

            val target = keyboardEvent.target as? HTMLTextAreaElement ?: return@addEventListener
            val indentSpaces = target.getAttribute("data-indent-spaces")?.toIntOrNull() ?: return@addEventListener
            val currentValue = target.value
            val selectionStart = target.selectionStart ?: currentValue.length
            val selectionEnd = target.selectionEnd ?: selectionStart
            val indent = " ".repeat(indentSpaces)

            keyboardEvent.preventDefault()
            target.value = buildString {
                append(currentValue.substring(0, selectionStart))
                append(indent)
                append(currentValue.substring(selectionEnd))
            }
            val nextCaret = selectionStart + indent.length
            target.selectionStart = nextCaret
            target.selectionEnd = nextCaret
            target.dispatchEvent(Event("input"))
        },
    )
}
